import {createSlice} from '@reduxjs/toolkit'

type LabelError = {
  code: string
  message: string
}

export type ShippingLabelErrorState = {
  labelErrors: LabelError[]
  showValidationMessageDialog: boolean
}

const initialState: ShippingLabelErrorState = {
  labelErrors: [],
  showValidationMessageDialog: false,
}

const shippingLabelErrorSlice = createSlice({
  name: 'searchProduct',
  initialState: initialState,
  reducers: {
    setLabelErrors: (state, action) => {
      state.labelErrors = action.payload
      state.showValidationMessageDialog = true
    },

    setShowValidationMessageDialog: (state, action) => {
      state.showValidationMessageDialog = action.payload
    },

    resetShippingLabelErrorState: () => {
      return initialState
    },
  },
})

export const {setLabelErrors, setShowValidationMessageDialog, resetShippingLabelErrorState} =
  shippingLabelErrorSlice.actions

export default shippingLabelErrorSlice.reducer
